export default {
      id: "ic-close-gray-solid-usage",
      viewBox: "0 0 12 13",
      url: "/" + "images/icons.3.109.2.svg#ic-close-gray-solid-usage",
      toString: function () {
        return this.url;
      }
    }